import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import EmployeeTracker from "@/pages/EmployeeTracker";
import EmployeeHistory from "@/pages/EmployeeHistory";
import AdminOverview from "@/pages/AdminOverview";
import AdminUsers from "@/pages/AdminUsers";
import AdminClients from "@/pages/AdminClients";
import ScreenshotsPage from "@/pages/ScreenshotsPage";
import ReportsPage from "@/pages/ReportsPage";
import InvoicesPage from "@/pages/InvoicesPage";
import ClientOverview from "@/pages/ClientOverview";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Employee */}
          <Route path="/track" element={
            <ProtectedRoute roles={["employee"]}><EmployeeTracker /></ProtectedRoute>
          } />
          <Route path="/history" element={
            <ProtectedRoute roles={["employee"]}><EmployeeHistory /></ProtectedRoute>
          } />

          {/* Admin / Super Admin */}
          <Route path="/admin" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><AdminOverview /></ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><AdminUsers /></ProtectedRoute>
          } />
          <Route path="/admin/clients" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><AdminClients /></ProtectedRoute>
          } />
          <Route path="/admin/screenshots" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><ScreenshotsPage scope="admin" /></ProtectedRoute>
          } />
          <Route path="/admin/reports" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><ReportsPage scope="admin" /></ProtectedRoute>
          } />
          <Route path="/admin/invoices" element={
            <ProtectedRoute roles={["super_admin"]}><InvoicesPage /></ProtectedRoute>
          } />

          {/* Client */}
          <Route path="/client" element={
            <ProtectedRoute roles={["client"]}><ClientOverview /></ProtectedRoute>
          } />
          <Route path="/client/screenshots" element={
            <ProtectedRoute roles={["client"]}><ScreenshotsPage scope="client" /></ProtectedRoute>
          } />
          <Route path="/client/reports" element={
            <ProtectedRoute roles={["client"]}><ReportsPage scope="client" /></ProtectedRoute>
          } />
          <Route path="/client/invoices" element={
            <ProtectedRoute roles={["client"]}><InvoicesPage scope="client" /></ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
